import { webPortalApi } from './web-portal-api';

const whitelist = import.meta.env.VITE_FREEZER_LINK_WHITE_LIST || '';
const whitelistHosts = whitelist.split(',');

function getWlName() {
  const { host } = window.location;

  // If host is whitelisted use it as whitelist name
  if (whitelistHosts.includes(host)) {
    return host;
  }

  let name = 'tracking.tec4med.com';

  if (!(host.includes('localhost') || host.includes('tec4med') || host.includes('192.168.'))) {
    name = host;
  }

  return name;
}

async function fetchWlConfig(wlName) {
  const response = await fetch(webPortalApi.buildStaticUrl(`whitelabel/${wlName}/whitelabel.json`));
  const data = await response.text();
  return JSON.parse(data);
}

const wlName = getWlName();
let wlConfig = null;

export const whitelabel = {
  async initConfig() {
    wlConfig = await fetchWlConfig(wlName);
  },
  getName: () => wlName,
  getConfig: () => wlConfig,
  buildAssetUrl: path => webPortalApi.buildStaticUrl(`whitelabel/${wlName}/${path}`)
};
